
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/[[...slug]]",
      function () {
        return require("private-next-pages/login/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/[[...slug]]"])
      });
    }
  